import { createContext } from 'react';

export const ActiveCardContext = createContext();